import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/close.svg';

export const IconClose = createIconComponent(Icon);
